import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { config } from './config';

import AffinityReport from './AffinityReport';

import * as filtersActions from '../../actions/filters-actions';
import * as queryActions from '../../actions/query-actions';
import * as segmentActions from '../../actions/audience-segment-actions';
import { getAllowedUserCountries } from '../../utils/filters';

import { getInlineQueryResults } from '../../reducers/query-reducer';
import './AffinityReport.css';

const mapStateToProps = state => ({
  queries: getInlineQueryResults(config.AFFINITY_REPORT_FILTERS.queries, state),
  filters: state.filters,
  allowedCountries: getAllowedUserCountries(state.user.allowedDataCategories)
});

const mapDispatchToProps = dispatch => ({
  filtersActions: bindActionCreators(filtersActions, dispatch),
  queryActions: bindActionCreators(queryActions, dispatch),
  segmentActions: bindActionCreators(segmentActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AffinityReport);
